import React from 'react';
import BubbleAlert from '../icons/BubbleAlert.jsx';
import './Badge.css';

export default function Badge({
  type       = 'basic',
  badgeStyle = 'filled',
  color      = 'gray',
  size       = 'small',
  label      = 'Badge',
  number     = null,
  icon: IconComponent = BubbleAlert,
  showIcon   = true,
  disabled   = false,
  className  = '',
}) {
  const resolvedStyle = disabled ? 'stroke' : badgeStyle;

  const rootClass = [
    'badge',
    `badge--${type}`,
    `badge--${size}`,
    disabled ? 'badge--disabled' : '',
    className,
  ].filter(Boolean).join(' ');

  const isNumber = number !== null && type === 'basic';

  const iconEl = showIcon && IconComponent
    ? <span className="badge__icon" aria-hidden="true"><IconComponent /></span>
    : null;

  return (
    <span className={rootClass} data-color={color} data-style={resolvedStyle}>
      {type === 'left-icon' && iconEl}
      {type === 'dot' && (
        <span className="badge__dot-container" aria-hidden="true">
          <span className="badge__dot" />
        </span>
      )}
      {isNumber
        ? <span className="badge__number">{number}</span>
        : <span className="badge__label">{label}</span>
      }
      {type === 'right-icon' && iconEl}
    </span>
  );
}
